export default "__VITE_ASSET__f8bdfb16__"